import { createCommand } from './index';
export var openPixelEditor = function openPixelEditor() {
  return createCommand({
    type: 'openPixelEditor'
  });
};
export var closePixelEditor = function closePixelEditor() {
  return createCommand({
    type: 'closePixelEditor'
  });
};
export var closePixelEditorAndSave = function closePixelEditorAndSave(saveTransform) {
  return createCommand({
    type: 'closePixelEditor'
  }, saveTransform);
};